<script>
import { mapActions, mapState } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'FerryPersonCategoryAdd',
  mixins: [
    validatorMixin,
  ],
  props: {
    shown: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      validForm: true,
      personCategory: null,
    };
  },
  computed: {
    ...mapState({
      saveError: state => state.transportation.personCategories.saveError,
      saveLoading: state => state.transportation.personCategories.saveLoading,
    }),
  },
  methods: {
    ...mapActions({
      addPersonCategory: 'transportation/addPersonCategory',
    }),
    savePersonCategory() {
      if (this.validForm) {
        this.addPersonCategory(this.personCategory)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
    resetPersonCategory() {
      this.personCategory = {
        name: null,
        fromAge: null,
        toAge: null,
        externalRef: null,
        active: true,
      };
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.$refs.addPersonCategoryForm.resetValidation();
        this.resetPersonCategory();
      }
    },
  },
  created() {
    this.resetPersonCategory();
  },
};
</script>

<template>
  <v-card>
    <v-form v-model="validForm" @submit.prevent="savePersonCategory" ref="addPersonCategoryForm">
      <v-card-title>
        <span class="headline">
          Add Person Category
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          The person category could not be saved - please reload the page and try again
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="personCategory.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="personCategory.fromAge"
                :rules="[rules.required]"
                :disabled="saveLoading"
                type="number"
                label="Age from"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="personCategory.toAge"
                :rules="[rules.required]"
                :disabled="saveLoading"
                type="number"
                label="Age to"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="personCategory.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the person category against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="personCategory.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Cancel
        </v-btn>
        <v-spacer/>
        <v-tooltip top>
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationPersonCategoryAdd.vue